import { z } from "zod"

import {
  containsNumbersOrSpecialCharacters,
  last4SsnPattern,
  goodleapSsnPattern,
} from "./regex"

export const ssn4or9 = z
  .string()
  .min(4, `must be at least 4 digits`)
  .max(9, `must be no more than 9 digits`)
  .refine(
    (v) => goodleapSsnPattern.test(v),
    `must be 4 or 9 digits without dashes`,
  )

export const last4ssn = z
  .string()
  .min(4, `must be at least 4 digits`)
  .max(4, `must be no more than 4 digits`)
  .refine((v) => last4SsnPattern.test(v), `must be 4 digits without dashes`)

export const stringNoNumbersOrSpecialCharacters = z
  .string()
  .refine(
    (v) => !containsNumbersOrSpecialCharacters.test(v),
    `may not contain numbers of special characters`,
  )

export const numberLikeGreaterThanZero = z.union([
  z.number().min(1, `must be greater than zero`),
  z.string().refine((i) => {
    const int = parseFloat(i)

    return isNaN(int) || int <= 0
  }, `must be greater than zero`),
])

export const emailSchema = z.string().email()

export const urlSchema = z.string().url()

export const numberLike = z.union([
  z.number(),
  z.string().refine((i) => {
    const int = parseFloat(i)

    return isNaN(int)
  }, `value must be a number`),
])

export const dateString = z
  .string()
  .refine((dob) => !isNaN(Date.parse(dob)), `date of birth is required`)
